import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { checkAuthAndRedirect } from '../store/actions'
import Loader from '../components/Page/Loader'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  align-items: center;
`

const Minted = styled.span`
  font-family: ${props => props.theme.fonts.primary.regular};
  color: ${props => props.theme.colors.black1};
  font-size: 55px;
`

const StyledDiv = styled.div`
  position: fixed;
  top: 40%;
`

export default function(Component) {
  class Authenticate extends React.Component {
    componentDidMount() {
      this._checkAndRedirect()
    }

    componentDidUpdate() {
      this._checkAndRedirect()
    }

    _checkAndRedirect = () => {
      this.props.dispatch(checkAuthAndRedirect())
    }

    render() {
      return this.props.isAuthenticated ? (
        <Component {...this.props} />
      ) : (
        <Container>
          <StyledDiv>
            <Minted>Find your data.</Minted>
            <Loader />
          </StyledDiv>
        </Container>
      )
    }
  }

  function mapStateToProps(state, ownProps) {
    return {
      isAuthenticated: state.user.isAuthenticated,
      ...ownProps,
    }
  }

  return connect(mapStateToProps)(Authenticate)
}
